import { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Environment } from '../../../constants/environments';
import { FixedParams, useEventContext } from '../../../hooks/contexts/event.context';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { useModalContext } from '../../../hooks/contexts/modal.context';
import { useUserContext } from '../../../hooks/contexts/user.context';
import * as Styles from './styles.modalAwaitingResponse';

const AwaitingResponse = () => {
  const [messageText, setMessageText] = useState('');
  const { translate } = useI18nContext();
  const { defineTitleModal, toggleModal } = useModalContext();
  const { event } = useEventContext();
  const {
    pollFacialRecognitionStatus, tryAgainRC, rfData, rFCheckWasSuccessful, errorWhenTryingToRegisterRf
  } = useUserContext();

  const { eventId } = useParams<FixedParams>();

  function makeErrorMessage (): string {

    if (errorWhenTryingToRegisterRf) {
      defineTitleModal(translate(['INFORMATION', 'UNABLE_TO_COMPLETE_REGISTRATION']));
      return translate(['INFORMATION', 'FACIAL_BIOMETRY_REGISTRATION_NOT_COMPLETED']);
    }

    if (rFCheckWasSuccessful) {
      defineTitleModal(translate(['INFORMATION', 'REGISTRATION_COMPLETED']));
      return translate(['INFORMATION', 'INFORMATION_RECEIVED_NO_REPEAT_REGISTRATION']);
    }

    defineTitleModal(translate(['INFORMATION', 'AWAITING_FACIAL_REGISTRATION']));
    return translate(['INFORMATION', 'FINALIZE_REGISTRATION_BEEPASS']);
  }

  useEffect(() => {
    if (!rFCheckWasSuccessful && !errorWhenTryingToRegisterRf && event) {
      pollFacialRecognitionStatus({ eventId : Number(eventId) });
    }
    setMessageText(makeErrorMessage());
  }, [rFCheckWasSuccessful, errorWhenTryingToRegisterRf, event]);

  return (
    <Fragment>
      <Styles.Wrapper id="loader-member-wrapper">
        {(!rFCheckWasSuccessful && !errorWhenTryingToRegisterRf) && (
          <Styles.Spinner viewBox="0 0 50 50" id="loader-member-spinner">
            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" id="loader-member-circle"/>
          </Styles.Spinner>
        )}
        <Styles.TextInfo
          $align={!rFCheckWasSuccessful && !errorWhenTryingToRegisterRf ? 'center' : 'left'}
          id="loader-member-text">
          {messageText}
        </Styles.TextInfo>
        {(rFCheckWasSuccessful || errorWhenTryingToRegisterRf) && (
          <Styles.WrapperButton>
            {rFCheckWasSuccessful ? (
              <Styles.Button
                $type="filled"
                onClick={() => toggleModal({ open : false })}
              >
                {translate(['INFORMATION', 'UNDERSTOOD'])}
              </Styles.Button>
            ): (
              <Fragment>
                <Styles.Button
                  $type="alpha"
                  onClick={() => window.open(Environment.SUPPORT_LINK, '_blank')}
                >
                  {translate(['INFORMATION', 'ACCESS_SUPPORT'])}
                </Styles.Button>
                <Styles.Button
                  $type="filled"
                  onClick={() => {
                    if (!rfData) {
                      throw new Error('onboarding_url is not defined');
                    }
                    tryAgainRC();
                    window.open(rfData.onboarding_url, '_blank');
                  }}
                >
                  {translate(['INFORMATION', 'REGISTER_BIOMETRY'])}
                </Styles.Button>
              </Fragment>
            )}
          </Styles.WrapperButton>
        )}
      </Styles.Wrapper>
    </Fragment>
  );
};

export default AwaitingResponse;
